var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-2"},[_c('BaseToggle',{attrs:{"inderteminate":_vm.loading,"disabled":_vm.loading},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}}),(_vm.rejected)?_c('BaseFormInlineMessage',{attrs:{"danger":""}},[_vm._v(" "+_vm._s(_vm.rejectReason)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }